import React, { useContext } from 'react'

import {
  timesActivity,
  numWinners,
} from '../../../constants/activity-constants'
import { Context } from './../../../context/app-context'
import useMediaQuery from './../../../utils/useMediaQuery'

import imgHomeTitle from './../../../assets/images/home_1.png'
import imgHomeActivityLogo from './../../../assets/images/encuentra_la_pareja.png'
import imgHomeActivityLogoPc from './../../../assets/images/encuentra_la_pareja_pc.png'

import imgQueEsperas from './../../../assets/images/que_esperas.png'
import imgBodegon from './../../../assets/images/home_bodegon.png'
import imgBodegonPeru from './../../../assets/images/home_bodegon_peru.png'
import imgBodegonArgentina from './../../../assets/images/home_bodegon_argentina.png'
import imgBodegonEcuador from './../../../assets/images/home_bodegon_ecuador.png'
import imgBodegonChile from './../../../assets/images/home_bodegon_chile.png'
import imgBodegonDominicana from './../../../assets/images/home_bodegon_dominicana.png'
import imgBodegonBolivia from './../../../assets/images/home_bodegon_bolivia.png'
import imgBodegonParaguay from './../../../assets/images/home_bodegon_paraguay.png'
import imgBodegonUruguay from './../../../assets/images/card-blocked.png'
import imgCardsGame from './../../../assets/images/home_cards.png'
import imgCardsGameArgentina from './../../../assets/images/home_cards_argentina.png'
import imgCardsGameChile from './../../../assets/images/home_cards_chile.png'
import imgCardsGameBolivia from './../../../assets/images/home_cards_bolivia.png'
import imgCardsGamePR from './../../../assets/images/home_cards_pr.png'
import icon25 from './../../../assets/images/icon25.png'
import icon20 from './../../../assets/images/icon20.png'

import logoCampana from './../../../assets/images/logoCampana.png'

import './home.scss'
import PoligonLogo from '../../atoms/poligon-logo/poligon-logo'
import Show from '../../../utils/show'
import { pushEventData } from '../../../utils/pushEventDataLayer'
import getUserInfo from '../../../utils/getUserInfo'
import { jsonToHash } from '../../../utils/crypto'
import { navigate } from 'gatsby'

const LOCALE =
  [
    'es-AR',
    'es-CL',
    'es-PE',
    'es-EC',
    'es-CL',
    'es-DO',
    'es-BO',
    'es-PR',
    'es-PY',
    'es-UY',
  ].indexOf(process.env.LOCALE) > -1
    ? process.env.LOCALE
    : 'default'

const italatam = LOCALE === 'es-AR' || LOCALE === 'es-PY' || LOCALE === 'es-UY'

const icono20 =
  LOCALE === 'es-AR' ||
  LOCALE === 'es-CL' ||
  LOCALE === 'es-PE' ||
  LOCALE === 'es-EC' ||
  LOCALE === 'es-CL' ||
  LOCALE === 'es-DO' ||
  LOCALE === 'es-PR' ||
  LOCALE === 'es-PY'

const userInfo = getUserInfo()
const handleClick = async label => {
  const user_data =
    userInfo !== null
      ? await jsonToHash([
          {
            nombre: userInfo.name,
            apellido: userInfo.lastName,
            celular: userInfo.cellPhone,
            correo: userInfo.email,
            ciudad: userInfo.location.cityName,
            departamento: userInfo.location.countryStateName,
            pais: userInfo.countryName,
          },
        ])
      : null
  pushEventData({
    event: 'Interacciones_Home_VMatch',
    label,
    user_data,
    log_status: userInfo ? 'Yes' : 'Not',
  })
}

export default function Home() {
  const isMobile = useMediaQuery(1300)
  const { dispatch } = useContext(Context)

  const handleModalOpen = () => {
    dispatch({
      type: 'set-context',
      payload: {
        modalActive: {
          type: 'unauthenticated',
          props: {},
        },
      },
    })
  }
  return (
    <div className="home">
      <div className="home-container">
        <div className="section section-1">
          <PoligonLogo />
        </div>
        <div className="section section-2">
          {!isMobile && (
            <>
              <Show
                valid={
                  LOCALE === 'default' ||
                  LOCALE === 'es-EC' ||
                  LOCALE === 'es-PE' ||
                  LOCALE === 'es-DO'
                }
              >
                <img
                  className="imgCardsGame"
                  src={imgCardsGame}
                  alt="iconos de actividad"
                />
              </Show>
              <Show valid={italatam}>
                <img
                  className="imgCardsGame"
                  src={imgCardsGameArgentina}
                  alt="iconos de actividad"
                />
              </Show>
              <Show valid={LOCALE === 'es-CL'}>
                <img
                  className="imgCardsGame"
                  src={imgCardsGameChile}
                  alt="iconos de actividad"
                />
              </Show>
              <Show valid={LOCALE === 'es-BO'}>
                <img
                  className="imgCardsGame"
                  src={imgCardsGameBolivia}
                  alt="iconos de actividad"
                />
              </Show>
              <Show valid={LOCALE === 'es-PR'}>
                <img
                  className="imgCardsGame"
                  src={imgCardsGamePR}
                  alt="iconos de actividad"
                />
              </Show>
            </>
          )}
          <div className="info-points">
            <p>
              <span className="info-points__redime">
                <Show
                  valid={
                    LOCALE === 'default' ||
                    LOCALE === 'es-EC' ||
                    LOCALE === 'es-DO' ||
                    LOCALE === 'es-PR'
                  }
                >
                  Redime
                </Show>
                <Show valid={LOCALE === 'es-PY' || LOCALE === 'es-AR'}>
                  Canjeá
                </Show>
                <Show valid={LOCALE === 'es-PE' || LOCALE === 'es-CL'}>
                  Canjea
                </Show>
              </span>{' '}
            </p>
            <Show valid={LOCALE === 'default'}>
              <img className="imgIcon25" src={icon25} alt="puntos a redimir" />
            </Show>
            <Show valid={icono20}>
              <img className="imgIcon25" src={icon20} alt="puntos a redimir" />
            </Show>
          </div>
          <Show valid={!italatam}>
            <p className="date-limit infoRedime">
              <span className="infoRedime__bold">
                Encuentra todas las parejas del Mundo Nosotras en tiempo record
              </span>
              , aprende mientras te diviertes y participa las veces que quieras.
            </p>
          </Show>
          <Show valid={LOCALE === 'es-PY' || LOCALE === 'es-AR'}>
            <p className="date-limit infoRedime">
              <span className="infoRedime__bold">
                Encontrá todas las parejas del Mundo Nosotras en tiempo record
              </span>
              , aprendé mientras te divertís y participá las veces que querás.
            </p>
          </Show>
          <button
            onClick={() => {
              //handleModalOpen()
              navigate('/juega')
              handleClick('Quiero jugar')
            }}
            className="CTA btn-primary f-concentrate-home-btn hoverButon"
          >
            ¡Quiero jugar!
          </button>
        </div>
        <div className="section section-3">
          <div className="section-3__info">
            <Show valid={LOCALE !== 'es-UY'}>
              <h2 className="topNumber">
                <span>Del top 1 al {numWinners}</span>
                <br />
                GANARÁN
              </h2>
            </Show>
            <Show valid={LOCALE === 'default'}>
              <img className="imgBodegon" src={imgBodegon} alt="Premios" />
            </Show>
            <Show valid={LOCALE === 'es-CL'}>
              <img className="imgBodegon" src={imgBodegonChile} alt="Premios" />
            </Show>
            <Show valid={LOCALE === 'es-AR'}>
              <img
                className="imgBodegon"
                src={imgBodegonArgentina}
                alt="Premios"
              />
            </Show>
            <Show valid={LOCALE === 'es-PE'}>
              <img className="imgBodegon" src={imgBodegonPeru} alt="Premios" />
            </Show>
            <Show valid={LOCALE === 'es-EC'}>
              <img
                className="imgBodegon"
                src={imgBodegonEcuador}
                alt="Premios"
              />
            </Show>
            <Show valid={LOCALE === 'es-DO' || LOCALE === 'es-PR'}>
              <img
                className="imgBodegon"
                src={imgBodegonDominicana}
                alt="Premios"
              />
            </Show>
            <Show valid={LOCALE === 'es-BO'}>
              <img
                className="imgBodegon"
                src={imgBodegonBolivia}
                alt="Premios"
              />
            </Show>
            <Show valid={LOCALE === 'es-PY'}>
              <img
                className="imgBodegon"
                src={imgBodegonParaguay}
                alt="Premios"
              />
            </Show>
            <Show valid={LOCALE === 'es-UY'}>
              <img
                className="imgBodegonUruguay"
                src={imgBodegonUruguay}
                alt="Premios"
              />
            </Show>

            <p className="pDescripcionBodogon">
              <Show valid={LOCALE !== 'es-UY'}>
                <span className="pDescripcionBodogon__spanTitle">
                  un increíble
                </span>{' '}
              </Show>

              <br />
              <Show valid={LOCALE === 'default'}>
                Kit de Productos Nosotras <br />+ Kit Vulvas
              </Show>
              <Show valid={LOCALE === 'es-CL'}>
                Kit de Productos Nosotras <br />+ un bolso y pulsera de la marca
              </Show>
              <Show valid={LOCALE === 'es-AR' || LOCALE === 'es-PE'}>
                Kit de Productos Nosotras <br />+ merchandising de la marca
              </Show>
              <Show valid={LOCALE === 'es-EC'}>
                Juego de brochas <br />+ un Jabón intimo Nosotras
              </Show>
              <Show valid={LOCALE === 'es-DO' || LOCALE === 'es-PR'}>
                Kit Nosotras Sensitiv
              </Show>
              <Show valid={LOCALE === 'es-BO'}>
                packs{' '}
                <span className="pDescripcionBodogon__spanTitle">
                  de wallpapers y templates para Instagram
                </span>
              </Show>
              <Show valid={LOCALE === 'es-PY'}>Kit de Productos Nosotras</Show>
              <Show valid={LOCALE === 'es-UY'}>
                Encontrá todas las parejas del Mundo Nosotras en tiempo record,
                <span className="pDescripcionBodogon__spanTitle">
                  {' '}
                  aprendé mientras te divertís y participá las veces que querás.
                </span>
              </Show>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
